import { render, staticRenderFns } from "./ElectricityPrice.vue?vue&type=template&id=2dfd35cc&scoped=true"
import script from "./ElectricityPrice.vue?vue&type=script&lang=js"
export * from "./ElectricityPrice.vue?vue&type=script&lang=js"
import style0 from "./ElectricityPrice.vue?vue&type=style&index=0&id=2dfd35cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd35cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dfd35cc')) {
      api.createRecord('2dfd35cc', component.options)
    } else {
      api.reload('2dfd35cc', component.options)
    }
    module.hot.accept("./ElectricityPrice.vue?vue&type=template&id=2dfd35cc&scoped=true", function () {
      api.rerender('2dfd35cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyPrice/ElectricityPrice/ElectricityPrice.vue"
export default component.exports